export enum FIELD_NAME {
  currentPassword = 'currentPassword',
  newPassword = 'newPassword',
  repeatPassword = 'repeatPassword',
}
